var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 346.6 475.3",
    style: {
      enableBackground: "new 0 0 346.6 475.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#414042;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#FFE296;}\r\n\t.st2{fill:none;stroke:#FFE39C;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 68.2,
    y1: 120.8,
    x2: 2.5,
    y2: 55.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 55.1,
    x2: 53.2,
    y2: 4.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "53.2,4.4 118.9,70.1 227.5,70.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,21.3l2.7,2.7c0.8,0.8,0.8,2,0,2.8L24.7,56.3c-0.8,0.8-2,0.8-2.8,0l-2.7-2.7c-0.8-0.8-0.8-2,0-2.8 L49,21.3C49.7,20.5,51,20.5,51.7,21.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 68.2,
    y1: 221.8,
    x2: 2.5,
    y2: 156.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 156.1,
    x2: 53.2,
    y2: 105.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.2,
    y1: 105.4,
    x2: 118.9,
    y2: 171.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,122.3l2.7,2.7c0.8,0.8,0.8,2,0,2.8l-29.6,29.6c-0.8,0.8-2,0.8-2.8,0l-2.7-2.7c-0.8-0.8-0.8-2,0-2.8 L49,122.3C49.7,121.5,51,121.5,51.7,122.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 68.2,
    y1: 322.8,
    x2: 2.5,
    y2: 257.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 257.1,
    x2: 53.2,
    y2: 206.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.2,
    y1: 206.4,
    x2: 118.9,
    y2: 272.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,223.3l2.7,2.7c0.8,0.8,0.8,2,0,2.8l-29.6,29.6c-0.8,0.8-2,0.8-2.8,0l-2.7-2.7c-0.8-0.8-0.8-2,0-2.8 L49,223.3C49.7,222.5,51,222.5,51.7,223.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-10"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "68.2,470.9 68.2,423.8 2.5,358.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 358.1,
    x2: 53.2,
    y2: 307.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.2,
    y1: 307.4,
    x2: 118.9,
    y2: 373.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,324.3l2.7,2.7c0.8,0.8,0.8,2,0,2.8l-29.6,29.6c-0.8,0.8-2,0.8-2.8,0l-2.7-2.7c-0.8-0.8-0.8-2,0-2.8 L49,324.3C49.7,323.5,51,323.5,51.7,324.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 278.2,
    y1: 120.8,
    x2: 343.9,
    y2: 55.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-14"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 343.9,
    y1: 55.1,
    x2: 293.2,
    y2: 4.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 293.2,
    y1: 4.4,
    x2: 227.5,
    y2: 70.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,53.7l-2.7,2.7c-0.8,0.8-2,0.8-2.8,0L292,26.7c-0.8-0.8-0.8-2,0-2.8l2.7-2.7c0.8-0.8,2-0.8,2.8,0L327,50.9 C327.8,51.7,327.8,52.9,327,53.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 278.2,
    y1: 221.8,
    x2: 343.9,
    y2: 156.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 343.9,
    y1: 156.1,
    x2: 293.2,
    y2: 105.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 293.2,
    y1: 105.4,
    x2: 227.5,
    y2: 171.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,154.7l-2.7,2.7c-0.8,0.8-2,0.8-2.8,0L292,127.7c-0.8-0.8-0.8-2,0-2.8l2.7-2.7c0.8-0.8,2-0.8,2.8,0 l29.6,29.6C327.8,152.7,327.8,153.9,327,154.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 278.2,
    y1: 322.8,
    x2: 343.9,
    y2: 257.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 343.9,
    y1: 257.1,
    x2: 293.2,
    y2: 206.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 293.2,
    y1: 206.4,
    x2: 227.5,
    y2: 272.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,255.7l-2.7,2.7c-0.8,0.8-2,0.8-2.8,0L292,228.7c-0.8-0.8-0.8-2,0-2.8l2.7-2.7c0.8-0.8,2-0.8,2.8,0 l29.6,29.6C327.8,253.7,327.8,254.9,327,255.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-22"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "278.2,470.9 278.2,423.8 343.9,358.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 343.9,
    y1: 358.1,
    x2: 293.2,
    y2: 307.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 293.2,
    y1: 307.4,
    x2: 227.5,
    y2: 373.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327,356.7l-2.7,2.7c-0.8,0.8-2,0.8-2.8,0L292,329.7c-0.8-0.8-0.8-2,0-2.8l2.7-2.7c0.8-0.8,2-0.8,2.8,0 l29.6,29.6C327.8,354.7,327.8,355.9,327,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,470.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "68.2,470.9 2.5,470.9 2.5,4.4 344.1,4.4 344.1,470.9 278.2,470.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.3,
    y1: 92.7,
    x2: 173.3,
    y2: 135.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.3,
    y1: 188.7,
    x2: 173.3,
    y2: 231.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.3,
    y1: 286.2,
    x2: 173.3,
    y2: 328.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.3,
    y1: 382.2,
    x2: 173.3,
    y2: 424.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingB);
export default __webpack_public_path__ + "static/media/parking-B.7f32237ac095c36045ce797cd3db1e4a.svg";
export { ForwardRef as ReactComponent };